import styled from "styled-components"
import colors from "~constants/colors"
import grid from "~constants/grid"
import { rgba } from "polished"

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TabList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  z-index: 10;
  gap: 0;
  background: ${colors.gray1};
  border: 1px solid ${colors.gray2};
  border-radius: 10px 10px 0 0;
  padding: 4px 4px 0;

  @media (max-width: ${grid.medium}) {
    flex-direction: column;
    border-radius: 10px 10px 0 0;
  }
`

export const TabButton = styled.button<{ $isActive: boolean }>`
  flex: none;
  padding: 9px 14px;
  background-color: ${({ $isActive }) =>
    $isActive ? colors.white : "transparent"};
  border: none;
  border-radius: 8px 8px 0 0;
  color: ${({ $isActive }) => ($isActive ? colors.blue1 : colors.gray6)};
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? "700" : "600")};
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  position: relative;
  transition:
    color 0.15s ease,
    background-color 0.15s ease;

  ${({ $isActive }) =>
    $isActive &&
    `
    box-shadow: 0 -2px 0 0 ${colors.blue1} inset;
  `}

  &:hover:not(:disabled) {
    background-color: ${({ $isActive }) =>
      $isActive ? colors.white : rgba(colors.white, 0.6)};
    color: ${({ $isActive }) => ($isActive ? colors.blue1 : colors.gray3)};
  }

  &:focus-visible {
    outline: 2px solid ${colors.blue1};
    outline-offset: -2px;
  }

  &:disabled {
    color: ${colors.gray6};
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (max-width: ${grid.medium}) {
    flex: none;
    width: 100%;
    text-align: left;
    padding: 12px 18px;
    border-radius: 0;
  }
`

export const TabPanels = styled.div`
  padding: 20px;
  background-color: ${colors.white};
  border: 1px solid ${colors.gray2};
  border-top: none;
  border-radius: 0 0 10px 10px;
`

export const TabPanel = styled.div`
  display: block;
  font-size: 14px;
`
